module.exports = __webpack_public_path__ + "static/media/21 - Laid Back - Bakerman.8b1ae37f.mp3";